import React, { useMemo } from 'react';
interface QrCodeProps {
  value: string;
  size?: number;
  inactive?: boolean;
  inactiveLabel?: string;
}
const N = 29;
function inFinder(r: number, c: number) {
  const zones = [[0, 0], [0, N - 7], [N - 7, 0]];
  return zones.some(([zr, zc]) => r >= zr && r < zr + 7 && c >= zc && c < zc + 7);
}
function finderCell(r: number, c: number) {
  const zones = [[0, 0], [0, N - 7], [N - 7, 0]];
  for (const [zr, zc] of zones) {
    const y = r - zr;
    const x = c - zc;
    if (y >= 0 && y < 7 && x >= 0 && x < 7) {
      return y === 0 || y === 6 || x === 0 || x === 6 || y >= 2 && y <= 4 && x >= 2 && x <= 4;
    }
  }
  return false;
}

/** Demo QR pattern derived from a release token. Not a decodable production QR. */
export function QrCode({
  value,
  size = 120,
  inactive = false,
  inactiveLabel = 'সক্রিয় নয়'
}: QrCodeProps) {
  const cells = useMemo(() => {
    let seed = 0;
    for (let i = 0; i < value.length; i++) seed = seed * 31 + value.charCodeAt(i) >>> 0;
    const out: boolean[] = [];
    for (let i = 0; i < N * N; i++) {
      seed ^= seed << 13;
      seed >>>= 0;
      seed ^= seed >> 17;
      seed ^= seed << 5;
      seed >>>= 0;
      out.push(seed % 2 === 0);
    }
    return out;
  }, [value]);
  return <div className="relative inline-block bg-white p-1.5" style={{
    width: size,
    height: size
  }} data-id="element-786" data-mp="1h36tom3xy2s0">
      <svg viewBox={`0 0 ${N} ${N}`} className={`w-full h-full ${inactive ? 'opacity-25' : ''}`} shapeRendering="crispEdges" role="img" aria-label={`QR কোড ${value}`} data-id="element-787" data-mp="1m0ozi3mnw1vs">
        {cells.map((on, i) => {
        const r = Math.floor(i / N);
        const c = i % N;
        const fill = inFinder(r, c) ? finderCell(r, c) : on;
        return fill ? <rect key={i} x={c} y={r} width={1} height={1} fill="#0F2133" data-id="element-788" data-mp="13binezgdi8iy" /> : null;
      })}
      </svg>
      {inactive && <div className="absolute inset-0 flex items-center justify-center" data-id="element-789" data-mp="og2oag0xrmfp">
          <span className="rounded bg-danger px-1.5 py-0.5 text-[10px] font-bold text-white text-center leading-tight" data-id="element-790" data-mp="te45swiprdp2">{inactiveLabel}</span>
        </div>}
    </div>;
}